import { FileClient, PageableResponse, RestClient } from "..";

export type B050030FindRequest = Partial<{
  shireYmdFrom: string;
  shireYmdTo: string;
  eigyoCdFrom: string;
  eigyoCdTo: string;
  bumonCdFrom: string;
  bumonCdTo: string;
  shainCdFrom: string;
  shainCdTo: string;
  hachudenpyoNoFrom: string;
  hachudenpyoNoTo: string;
  shireCd: string;
  shodaibun: string;
  shochubun: string;
  shoshobun: string;
  shohinCd: string;
  janCd: string;
  page: number;
  sort: string[];
  size: number;
}>;

export type B050030FindResponse = {
  uchiwakeNmr: string;
  shireYmdF: string;
  hachudenpyoNoF: string;
  shohinCd: string;
  shohinNm: string;
  shiresu: string;
  shireKin: string;
  shireNm: string;
  shainNm: string;
  bumonNmr: string;
  shiredenpyoNo: string;
};

// 検索メソッド
export const B050030Find = (props: B050030FindRequest) => {
  return RestClient.get<PageableResponse<B050030FindResponse>>("b050030/find", {
    params: props,
  });
};

// 発注明細データExcel出力メソッド
export const B050030GetExcel = (props: B050030FindRequest) => {
  return FileClient.get("b050030/get/excel", {
    params: props,
  });
};
